import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Viga

  <span style="color:#85c1dc;">**FI:**</span>
  Virhe

  <span style="color:#85c1dc;">**RU:**</span>
  Ошибка
*/
/* @__NO_SIDE_EFFECTS__ */
const m895 = msg(
  mf`Viga`,
  mf`Virhe`,
  mf`Ошибка`,
)

export { m895 as 'errors.page.not-found.title' }